/* -------------------------------------------
Imports
------------------------------------------- */

// import { MarkerClusterer } from "@googlemaps/markerclusterer";

/* -------------------------------------------
Map Controller
------------------------------------------- */

export default class GoogleMapController {
  constructor() {
    let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Create a new div to hold the map
    this.element = document.createElement('div');
    // Create a new array to hold all the markers
    this.markers = [];
    // Create a new map
    this.map = new google.maps.Map(this.element, settings);
    // Create a new clusterer
    this.clusters = [];

    // Add a class to the map
    this.element.classList.add('map-controller');
  }
  getMarkerDefaults() {
    // A default svg pin for the marker
    // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32"><path fill="#243D21" fill-rule="evenodd" d="M12 16.526 5.63 8.79h12.74L12 16.526ZM12 0C5.373 0 0 5.261 0 11.752 0 22.58 12 32 12 32s12-10.927 12-20.248C24 5.262 18.627 0 12 0Z" /></svg>
    const pin = 'M18.5 27.753c-4.949 0-8.961-4.054-8.961-9.057 0-5 4.012-9.056 8.961-9.056 4.949 0 8.961 4.055 8.961 9.056 0 5.003-4.012 9.057-8.961 9.057M18.5 0C8.283 0 0 8.37 0 18.696 0 36.737 18.5 60 18.5 60S37 36.173 37 18.696C37 8.371 28.717 0 18.5 0';
    const defaults = {
      path: pin,
      fillOpacity: 1,
      strokeWeight: 0,
      size: new google.maps.Size(37, 60),
      anchor: new google.maps.Point(18, 60)
    };
    return defaults;
  }
  addMarker() {
    let locationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let iconSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const marker = {};
    const defaults = this.getMarkerDefaults();

    // Merge the defaults with the settings
    const icon = {
      ...defaults,
      ...iconSettings
    };

    // Load the location data into the marker
    marker.data = locationData;
    // Create a new google maps marker
    marker.pin = new google.maps.Marker({
      icon,
      map: this.map,
      position: {
        lat: parseFloat(locationData.location.latitude),
        lng: parseFloat(locationData.location.longitude)
      }
    });

    // Add the marker to the markers array
    this.markers.push(marker);
    return marker;
  }
  clearMarkers() {
    // Loop the markers
    this.markers.forEach(marker => {
      // Remove the marker from the map
      marker.pin.setMap(null);
    });

    // Reset the markers array
    this.markers = [];
  }
  addInfoWindows(func, onClick) {
    if (!func || typeof func != 'function') return;
    this.markers.forEach(marker => {
      // Create a new info window
      const infoWindow = new google.maps.InfoWindow({
        content: func(marker.data)
      });

      // Add the info window to the marker
      marker.infoWindow = infoWindow;

      // Add a click event to the marker
      marker.pin.addListener('click', () => {
        // Close all the info windows
        this.closeInfoWindows();
        // Open the info window
        infoWindow.open(this.map, marker.pin);
      });

      // If the onClick function is a function, add a click event to the info window
      if (!onClick || typeof onClick != 'function') return;
      google.maps.event.addListener(infoWindow, 'domready', () => {
        onClick(marker.data);
      });
    });
  }
  closeInfoWindows() {
    // Loop all the markers in the group
    this.markers.forEach(marker => {
      // if the marker does not have an info window, return
      if (!marker.infoWindow) return;

      // Close the info window
      marker.infoWindow.close();
    });
  }
  recenter() {
    const bounds = new google.maps.LatLngBounds();

    // Extend the bounds to include the markers in the active filter
    this.markers.forEach(marker => {
      bounds.extend(marker.pin.getPosition());
    });

    // Loop the clusters
    this.clusters.forEach(cluster => {
      // Loop the markers in the cluster
      cluster.markers.forEach(marker => {
        // Extend the bounds to include the marker
        bounds.extend(marker.getPosition());
      });
    });
    this.map.fitBounds(bounds);

    // if the map is zoomed in too far, zoom out
    if (this.map.getZoom() > 13) this.map.setZoom(13);
  }
  setPosition(position) {
    // Merge the position object with the default position
    position = Object.assign({
      lat: 0,
      lng: 0,
      zoom: this.map.getZoom()
    }, position);

    // Set the map position
    this.map.panTo({
      lat: parseFloat(position.latitude),
      lng: parseFloat(position.longitude)
    });

    // Set the map zoom
    this.map.setZoom(parseFloat(position.zoom));
  }
  setStyles() {
    let styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // Set the map styles
    this.map.setOptions({
      styles
    });
  }
}